import { Container } from "@mui/material";

import { EventPageSkeleton } from "./EventPageSkeleton";
import { EventHeader } from "../../../layout/event/EventHeader";
import { EventScheduleSnippet } from "../../../layout/event/EventScheduleSnippet";
import { EventDivisionList } from "../../../layout/event/EventDivisionList";
import { EventTeamLeaderboardSnippet } from "../../../layout/event/leaderboard/EventTeamLeaderboardSnippet";
import { EventSearch } from "./EventSearch";
import { useEvent } from "./EventProvider";
import { EventPricing } from "../../../layout/event/EventPricing";
import { useMeta } from "hooks/useMeta";
import { useLocalizationContext } from "components/providers/LocalizationProvider";
import dayjs from "dayjs";
import { SHORT_DATE } from "utils/dates";
import { EVENT_STATUSES } from "components/layout/event/EVENT_STATUSES";
import { getEventWithStatusMetadataDescription } from "utils/metadata";
import { addRecentlyViewed } from "components/routes/root/useRecentlyViewed";
import { addRecentOrganisation } from "components/routes/root/useRecentOrganisations";

const EventPage = () => {
    const event = useEvent();

    const { translate } = useLocalizationContext();
    const eventDate = dayjs(event?.date).format(SHORT_DATE);
    const eventStatus = translate(EVENT_STATUSES[event?.status]);

    const translationProps = {
        eventName: event?.name,
        orgName: event?.organisation?.name,
        eventStatus: eventStatus,
        sportType: translate(event?.organisation?.sportType),
        eventDate: eventDate,
        eventLocation: event?.location?.placePredictionText,
    };
    useMeta({
        title: `${translationProps.eventName} - ${translationProps.orgName} | Liveheats`,
        description: getEventWithStatusMetadataDescription(translationProps),
        translationProps,
        skip: !translationProps.eventName || !translationProps.orgName,
    });

    if (!event) return <EventPageSkeleton/>;

    addRecentOrganisation({
        name: event.organisation.name,
        shortName: event.organisation.shortName,
        logo: event.organisation.logo,
    });
    addRecentlyViewed({ type: "event", data: {
        id: event.id,
        name: event.name,
        status: event.status,
        date: event.date,
        daysWindow: event.daysWindow,
        organisation: {
            name: event.organisation.name,
            logo: event.organisation.logo,
            sportType: event.organisation.sportType,
        }
    } });

    return (
        <Container>
            <EventHeader event={event}/>
            <EventSearch event={event}/>
            <EventScheduleSnippet event={event}/>
            {event.config?.teamLeaderboard && <EventTeamLeaderboardSnippet/>}
            <EventPricing event={event}/>
            <EventDivisionList event={event}/>
        </Container>
    );
};
export default EventPage;
